import cookie from '@ms/utils/cookie.js'

export function generateDeviceId() {
  let d = Date.now()
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = ((d + Math.random() * 16) % 16) | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return uuid
}

export const getDeviceId = () => {
  let deviceId = cookie.get('device-id')
  if (!deviceId) {
    deviceId = generateDeviceId()
    cookie.set('device-id', deviceId, {
      path: '/',
      expires: 1000
    })
  }
  return deviceId
}
